import React, {useEffect, useState} from 'react'
import {
    Container,
    Text,
    TextTag,
    TokenTextAppearance,
    Breakpoints,
    CTA,
} from '@volkswagen-onehub/components-core'
import {SizeEnum} from '@volkswagen-onehub/tokens'
import {ChevronDown} from '@volkswagen-onehub/icons-core'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {RootState} from '../rootReducer'
import {Global} from '../../shared/variables'
import {FaqAccordion} from '../components/FaqAccordion'

export function DealerFaq(): React.JSX.Element {
    const {t} = useTranslation('fa-flotte')

    const serviceType = useSelector(
        (state: RootState) => state.general.serviceType
    )

    const isPrivate = serviceType === Global.PRIVATE

    const [accordions, setAccordions] = useState([])
    const [showAllItems, setShowAllItems] = useState(false)

    const handleShowMore = () => {
        setShowAllItems(!showAllItems)
    }

    useEffect(() => {
        setAccordions(t('dealer-form.faq.accordions', {returnObjects: true}))
    }, [])

    return (
        <Container
            padding={{
                top: {
                    [Breakpoints.default]: SizeEnum.dynamic0300,
                },
                bottom: {
                    [Breakpoints.default]: SizeEnum.dynamic0250,
                },
            }}
            gutter={SizeEnum.static350}
            wrap="always"
        >
            <Text
                id="faqTitle"
                tag={TextTag.h2}
                appearance={TokenTextAppearance.headline300}
            >
                <span
                    dangerouslySetInnerHTML={{
                        __html: isPrivate
                            ? t('dealer-form.faq.title-private')
                            : t('dealer-form.faq.title-business'),
                    }}
                />
            </Text>

            <Container
                padding={{
                    left: {
                        [Breakpoints.b560]: SizeEnum.grid002,
                        [Breakpoints.b960]: SizeEnum.grid001,
                    },
                    right: {
                        [Breakpoints.b560]: SizeEnum.grid002,
                        [Breakpoints.b960]: SizeEnum.grid001,
                    },
                }}
                wrap="always"
            >
                {accordions.map(
                    (accordion: any, index) =>
                        (index <= Global.THREE || showAllItems) && (
                            <FaqAccordion
                                key={index}
                                title={accordion.question}
                                text={accordion.answer}
                                index={index}
                            />
                        )
                )}
            </Container>

            {accordions.length > Global.FOUR ? (
                <Container
                    padding={{
                        left: {
                            [Breakpoints.b560]: SizeEnum.grid002,
                            [Breakpoints.b960]: SizeEnum.grid001,
                        },
                        right: {
                            [Breakpoints.b560]: SizeEnum.grid002,
                            [Breakpoints.b960]: SizeEnum.grid001,
                        },
                        top: {
                            [Breakpoints.default]: SizeEnum.static350,
                        },
                    }}
                    wrap="always"
                >
                    {!showAllItems && (
                        <CTA
                            tag="button"
                            emphasis="secondary"
                            onClick={handleShowMore}
                            aria-label={t('cta.show-more')}
                            icon={<ChevronDown aria-hidden />}
                        >
                            {t('cta.show-more')}
                        </CTA>
                    )}
                </Container>
            ) : undefined}
        </Container>
    )
}
